import { stringOps } from './evaluators/string-ops.js';
import { literalOps } from './evaluators/literal-ops.js';
import { crossFieldOps } from './evaluators/cross-field-ops.js';
import { logicOps } from './evaluators/logic-ops.js';
import { lookupOps } from './evaluators/lookup-ops.js';
import { numberOps } from './evaluators/number-ops.js';
import { dateOps } from './evaluators/date-ops.js';
const ALL_OPS = [
    ...stringOps,
    ...literalOps,
    ...crossFieldOps,
    ...logicOps,
    ...lookupOps,
    ...numberOps,
    ...dateOps,
];
export const TRANSFORM_VOCAB = Object.fromEntries(ALL_OPS.map((op) => [op.id, op]));
export function getOpDef(id) {
    return TRANSFORM_VOCAB[id];
}
export function listOpsByFamily() {
    const grouped = {
        string: [],
        literal: [],
        'cross-field': [],
        logic: [],
        lookup: [],
        number: [],
        date: [],
    };
    for (const op of ALL_OPS) {
        // compat shims live in TRANSFORM_VOCAB for engine resolution but are not offered in the picker
        if (op.hiddenFromPicker)
            continue;
        grouped[op.family].push(op);
    }
    return grouped;
}
//# sourceMappingURL=transform-vocab.js.map